import api from '../index'

/**
 * @param {object} data 传参
 * @description 请求路径
 * @returns {Promise} 请求结果
 */
export const uploadUrl = `${api.baseUrl}/common/files/upload`
/**
 * @param {object} data 传参
 * @description 备课上传路径
 * @returns {Promise} 请求结果
 */
export const prepareUploadUrl = `${api.baseUrl}/teacher/lessonPreparation/upload`
/**
 * @param {object} data 传参
 * @description 用户导入路径
 * @returns {Promise} 请求结果
 */
export const userImportUrl = `${api.baseUrl}/admin/users/import`

/**
 * @param {object} data 传参
 * @description 上传选择的化合物文件
 * @returns {Promise} 请求结果
 */
export const snarUploadUrl = `${api.baseUrl}/common/snar/uploadFile`

/**
 * @description 上传文件
 * @returns {Promise} 请求结果
 */
export function reqUploadFile(formData: any) {
  return api.post('/common/files/upload', formData)
}
/**
 * @description 上传文件
 * @returns {Promise} 请求结果
 */
export function reqDownFile(formData: any) {
  return api.post('/common/download/file', formData)
}
/**
 * @description 用于统计下载量
 * @returns {Promise} 请求结果
 */
export function reqDownRecord(formData: any) {
  return api.post('/common/knowledgeFiles/recordDownload', formData)
}
